module.exports = __webpack_public_path__ + "img/USMegaMillions.1f6996f9.png";